/**
 * page-tear transition: M5.T4.
 *
 * Per IMPLEMENTATION_PLAN.md §7 M5.T4:
 *   "tear-line SVG animates across the canvas (300ms), current canvas
 *    slides up + fades 30%, new lobby/wordPick screen slides up from
 *    below. Used at `reveal → wordPick` and `reveal → gameOver`."
 *
 * Implementation: applied to the *incoming* phase shell. The shell root
 * gets `PAGE_TEAR_IN_CLASS`, which slides it in 40px from below + fades
 * from 0 → 1 over 300ms. A `<PageTearLine />` SVG sits at the top of
 * the shell and draws itself in via stroke-dashoffset over the same
 * 300ms, giving the torn-paper top-edge effect.
 *
 * Out-going animation (old screen slides up + fades to 30%) is deferred
 *: the incoming slide-from-below visually occludes the old screen, so
 * the cheap one-sided implementation reads as a page turn.
 *
 * Reduced motion: `@media (prefers-reduced-motion: reduce)` in anim.css
 * collapses the slide/fade to a no-op and removes the dash-draw on the
 * tear line.
 */

export const PAGE_TEAR_IN_CLASS = "page-tear-in";
export const PAGE_TEAR_DURATION_MS = 300;

/**
 * Torn-paper top edge for the incoming screen. Renders a wobbly
 * horizontal path that "draws" itself in via stroke-dashoffset.
 *
 * The SVG is intrinsically 100% wide × 12px tall with
 * preserveAspectRatio="none" so it stretches to any container.
 */
export function PageTearLine() {
  return (
    <svg class="page-tear-line" viewBox="0 0 400 12" preserveAspectRatio="none" aria-hidden="true">
      {/* Wobbly tear path: alternating zigzag to mimic a torn page edge */}
      <path
        d={
          "M 0 8 " +
          "C 20 4 40 10 60 6 " +
          "S 100 10 130 5 " +
          "S 180 9 215 4 " +
          "S 260 11 295 5 " +
          "S 340 9 380 6 " +
          "L 400 7"
        }
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
